import { ResponseState, ResponseFailedReason } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';

export type YetiReview = any;

export enum Reviews3FieldName {
    Date = 'date',
    DocumentId = 'document_id',
    UpdatedDate = 'updated_date',
    Labels = 'r4e_label_ids',
    Text = 'raw_body_text',
    Media = 'expanded_post_media',
    AggregatedAt = 'aggregated_at',
    Source = 'source',
    LocationUid = 'r4e_location_uid',
    NormalizedRating = 'rep_normalized_rating',
    RespondableType = 'respondable_type',
    Id = 'id',
}

// Review specific fields from top-level filters
export enum ReviewCoreFieldName {
    Date = 'R4EComment2.reviewCore.date',
    Sentiment = 'R4EComment2.reviewCore.sentiment',
    CategoryId = 'R4EComment2.reviewCore.categoryID',
    ResponseStatus = 'R4EComment2.reviewCore.responseStatus',
}

export enum Reviews3SortOrder {
    Asc = 'ASC',
    Desc = 'DESC',
}

export interface GetReviews3Args {
    agencyId?: number;
    reviewDate?: string;
    includePage?: boolean;
    includeSource?: boolean;
    includeLabels?: boolean;
    includeLocation?: boolean;
    includeAssignee?: boolean;
    includeResponses?: boolean;
    includeCredentials?: boolean;
    includeApproverIds?: boolean;
    includeAttributionUsers?: boolean;
    includeCredentialStatus?: boolean;
}

export interface SetResponseStateArgs {
    agencyId?: number;
    responseState: ResponseState;
    responseFailedReason?: ResponseFailedReason;
    responseFailedReasonExplanation?: string;
}

interface Media {
    name?: string;
    mediaType?: string;
    mimeType?: string;
    title?: string;
    url?: string;
}

export interface PublishRequest {
    id?: string;
    text?: string;
    medias?: Media[] | null;
    parentID: string;
    manualPublish?: boolean;
    reviewDate?: string;
}

interface ReviewResponseStateUpdate {
    id: string;
    manualPublish: boolean;
}

export interface BulkUpdateRequest {
    reviewResponseStateUpdates: ReviewResponseStateUpdate[];
    approved: boolean;
}

interface Distribution {
    email?: string;
    userID?: string;
    roledID?: string;
}

export interface ForwardEmailRequest {
    reviewId: string;
    params?: Record<string, any>;
    distributions: Distribution[];
    subject: string;
    message: string;
}

export enum AttributionType {
    Manual = 'Manual',
    Requestor = 'Requestor',
    Mention = 'Mention',
}

export enum RespondableType {
    Responded = 'RESPONDED',
    Unresponded = 'UNRESPONDED',
    NotRespondable = 'NOT_RESPONDABLE',
}

export const ResponseMapping = new Map<number, string>([
    [-6, 'UNRESPONDED'],
    [6, 'RESPONDED'],
    [-21, 'NOT_RESPONDABLE'],
]);

export enum ExportType {
    Csv = 'CSV',
    Excel = 'EXCEL',
}

export enum Sentiment {
    Negative = -1,
    Neutral = 0,
    Positive = 1,
    None = -2,
}

export const ReviewSentimentToCommon: Record<number, number> = {
    [Sentiment.Positive]: 1,
    [Sentiment.Negative]: 2,
    [Sentiment.Neutral]: 3,
    [Sentiment.None]: 4,
};
